﻿import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/pg_franquia/franquia-analises-tendencias";

export const Route = createFileRoute("/_authenticated/franquia-analises-tendencias")({
  head: () => ({
    meta: [
      { title: "Tendências — Milky Moo Palmares" },
      {
        name: "description",
        content: "Evolução e tendências de vendas por produto, seção e insumo.",
      },
      { property: "og:title", content: "Tendências — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Evolução e tendências de vendas por produto, seção e insumo.",
      },
    ],
  }),
  component: PaginaRota,
});
